/**
 * Controls the maximum number of items per page.
 */
const NUM_PER_PAGE = 20;

class CategoryPagesHandler extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.wrapperModal = document.querySelector(".category-pages__wrapper");
    this.modal = document.querySelector(".category-pages__modal");
    this.linksWrapper = document.querySelector(".category-pages__scroll");
    this.links = document.querySelectorAll(".category-pages__single-page");
    this.closeButton = document.querySelector(".category-pages__close");
    this.categoryContent = document.querySelector(".category-pages__content");

    const openInModal = this.linksWrapper.getAttribute("data-open-in-modal");
    if (openInModal && openInModal !== "false") {
      this.links.forEach((link) => {
        link.addEventListener("click", (event) => {
          this.handlePageClick(event);
        });
      });
    }

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => {
        this.closeModal();
      });
    }

    this.initializePagination();
  }

  disconnectedCallback() {
    this.deinitializePagination();
  }

  initializePagination() {
    this.currentPageIdx = 0;
    this.numPages = Math.max(Math.ceil(this.links.length / NUM_PER_PAGE), 1);
    this.linksArray = Array.from(this.links);

    this.prevBtn = document.querySelector(
      ".category-pages__pagination-btn--prev"
    );
    this.prevBtn.addEventListener("click", () => this.prevPage());

    this.nextBtn = document.querySelector(
      ".category-pages__pagination-btn--next"
    );
    this.nextBtn.addEventListener("click", () => this.nextPage());

    this.paginationPagesWrapper = document.querySelector(
      ".category-pages__pagination-pages-wrapper"
    );
    this.paginationPagesWrapper.replaceChildren();

    for (let i = 0; i < this.numPages; i++) {
      const btn = document.createElement("button");
      btn.classList.add("category-pages__pagination-btn");
      btn.classList.add("category-pages__pagination-btn--page");
      btn.setAttribute("data-id", i);
      btn.textContent = i + 1;

      btn.addEventListener("click", () => this.goToPage(i));

      this.paginationPagesWrapper.append(btn);
    }

    this.goToPage(0);
  }

  deinitializePagination() {
    this.nextBtn?.removeEventListener("click", () => this.nextPage());
  }

  prevPage() {
    if (this.currentPageIdx - 1 < 0) {
      return;
    }

    this.goToPage(this.currentPageIdx - 1);
  }

  nextPage() {
    if (this.currentPageIdx + 1 >= this.numPages) {
      return;
    }

    this.goToPage(this.currentPageIdx + 1);
  }

  goToPage(pageIdx) {
    this.currentPageIdx = pageIdx;
    for (const link of this.linksArray) {
      link.classList.add("hidden");
    }

    const currPage = this.linksArray.slice(
      NUM_PER_PAGE * this.currentPageIdx,
      NUM_PER_PAGE * (this.currentPageIdx + 1)
    );
    for (const link of currPage) {
      link.classList.remove("hidden");
    }

    if (this.currentPageIdx === 0) {
      this.prevBtn.setAttribute("disabled", "disabled");
    } else {
      this.prevBtn.removeAttribute("disabled");
    }

    if (this.currentPageIdx >= this.numPages - 1) {
      this.nextBtn.setAttribute("disabled", "disabled");
    } else {
      this.nextBtn.removeAttribute("disabled");
    }

    for (const btn of this.paginationPagesWrapper.children) {
      if (btn.getAttribute("data-id") == this.currentPageIdx) {
        btn.classList.add("active");
      } else {
        btn.classList.remove("active");
      }
    }
  }

  handlePageClick(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const urlPage = link.getAttribute("href");
    document.body.classList.add("blocked");
    this.wrapperModal.classList.add("show");
    window.scrollTo(0, 0);
    this.modal.classList.add("loading");

    fetch(urlPage)
      .then((response) => response.text())
      .then((data) => {
        console.log({ data });
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");
        const newSection = doc.getElementById(
          "shopify-section-category-single"
        );

        if (newSection) {
          if (this.categoryContent) {
            this.categoryContent.innerHTML = newSection.outerHTML;
            this.modal.classList.remove("loading");
            new SimpleBar(
              document.querySelector(".category-single-page__scroll-js"),
              { scrollbarMaxSize: 100 }
            );
          } else {
            console.error(".category-pages__content element not found");
          }
        } else {
          console.error("Section not found in the parsed HTML");
        }
      })
      .catch((error) => {
        console.error("Error fetching the page:", error);
      });
  }

  closeModal() {
    document.body.classList.remove("blocked"); // Удаляем класс 'blocked' с body
    this.wrapperModal.classList.remove("show");
    if (this.categoryContent) {
      this.categoryContent.innerHTML = ""; // Очищаем содержимое
    }
  }
}

customElements.define("category-pages-handler", CategoryPagesHandler);

document.addEventListener("DOMContentLoaded", () => {
  const handler = document.createElement("category-pages-handler");
  document.body.appendChild(handler);
});
